<template>
  <div>
    <div class="hint">微信登录</div>
    <div class="we-chat" @click="onWXLogin()">
      <img src="@/assets/images/weChat.png" alt="">
    </div>
  </div>
</template>
<script>
  import wx from "weixin-js-sdk";
  export default {
    props: ["WeixinLoginApi"],
    data() {
      return {};
    },
    methods: {
      onWXLogin() {
        var url = window.location.pathname + window.location.search;
        var redirect =
          window.location.hash.replace("#", "") || window.location.href;
        var returnUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          "/transferLogin?r=" +
          encodeURIComponent(url);
        window.location.href =
          this.baseURL +
          this.WeixinLoginApi +
          window.encodeURIComponent(returnUrl);
      }
    }
  };

</script>
<style lang="less" scoped>
  

  .hint {
    text-align: center;
    font-size: 28/@rem-size;
    color: #999;
    margin-top: 80/@rem-size;
  }

  .we-chat {
    width: 100/@rem-size;
    height: 100/@rem-size;
    margin: 0 auto;
    margin-top: 30/@rem-size;
    cursor: pointer;
  }

</style>
